import router from '@/router'
import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'

export const isAuthenticated = (): boolean => useAppStore().isLoggedIn()

// The API clears the HttpOnly JWT cookie on GET /logout; then the local login state goes and
// the user lands on the login page.
export const logout = async (): Promise<void> => {
    const appStore = useAppStore()
    try {
        await useFetchStore().fetch('/logout').get()
    } finally {
        appStore.setLogout()
        await router.push({ name: 'login' })
    }
}
